module.exports = __webpack_public_path__ + "img/sorento-19.a07072c0.jpg";